<template>
  <a href="#" class="form__link" @click.prevent="sendRequest">{{deletionStatus ? 'Восстановить анкету' : 'Удалить анкету'}}</a>
</template>

<script>
  export default {
    name: "DeleteQuestionnaireBtn",
    computed: {
      deletionStatus() {
        return this.$store.state.deletionStatus;
      }
    },
    methods: {
      async sendRequest() {
        await this.$store.dispatch('deletionRecall');
      }
    }
  }
</script>
